import { useAuth } from "vue-clerk";
import { defineNuxtRouteMiddleware, navigateTo, useRuntimeConfig } from "#imports";
export default defineNuxtRouteMiddleware((to) => {
  const { userId } = useAuth();
  if (!userId.value) {
    return;
  }
  const config = useRuntimeConfig().public.clerk;
  const redirectUrl = to.meta.auth?.navigateAuthenticatedTo || to.meta.auth?.authenticatedRedirectUrl || config.signInForceRedirectUrl || config.signInFallbackRedirectUrl;
  return navigateTo(redirectUrl);
});
